import React, { lazy, Suspense, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../components/reusable-loader/Loader";
import ProtectedRoute from "./ProtectedRoutes";
import Login from "../pages/auth/Login";
// import MainPage from "../pages/main-pages/MainPage";
// import InspectorsList from "../pages/main-pages/manage-inspectors/Inspectors-list/InspectorsList";
// import ManageAdmins from "../pages/main-pages/manage-admins/admins-list/AdminsList";
// import SubmittedReports from "../pages/main-pages/submitted-reports/SubmittedReports";
// import ProtectedRoute from "./ProtectedRoutes";
// import InspectorReportDetails from "../pages/main-pages/manage-inspectors/details/Details";

const AppRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<string | null>(
    localStorage.getItem("tobacco_access_token")
  );

  // const LoginPage = lazy(() => import("../pages/auth/Login"));
  const MainPage = lazy(() => import("../pages/main-pages/MainPage"));
  const InspectorsList = lazy(
    () =>
      import(
        "../pages/main-pages/manage-inspectors/Inspectors-list/InspectorsList"
      )
  );
  const ManageAdmins = lazy(
    () => import("../pages/main-pages/manage-admins/admins-list/AdminsList")
  );
  const SubmittedReports = lazy(
    () => import("../pages/main-pages/submitted-reports/SubmittedReports")
  );
  // const ProtectedRoute = lazy(() => import("./ProtectedRoutes"));
  const InspectorReportDetails = lazy(
    () => import("../pages/main-pages/manage-inspectors/details/Details")
  );

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path="/login"
          element={<Login setIsAuthenticated={setIsAuthenticated} />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <MainPage setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="manage-inspector" replace />} />
          <Route path="manage-inspector" element={<InspectorsList />} />
          <Route path="manage-admin" element={<ManageAdmins />} />
          <Route path="submitted-reports" element={<SubmittedReports />} />
          <Route
            path="inspector-report/:id"
            element={<InspectorReportDetails />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
